import { createAction, props } from '@ngrx/store';
import { HttpResponse } from '@angular/common/http';

export enum DownloadCsvActions {
    downloadCsv = '[CsvDownload] Download Csv',
    downloadCsvSuccess = '[CsvDownload] Download Csv Success',
    downloadCsvFailure = '[CsvDownload] Download Csv Failure',
}

export const DownloadCsv = createAction(
    DownloadCsvActions.downloadCsv,
    props<{ blob: HttpResponse<Blob> }>()
)

export const DownloadCsvSuccess = createAction(
    DownloadCsvActions.downloadCsvSuccess,
    props<{ res: HttpResponse<Blob> }>()
)

export const DownloadCsvFailure = createAction(
    DownloadCsvActions.downloadCsvFailure,
    props<Error>()
)
